// 定义Modal组件的类型
import React, {useContext, useEffect, useState} from "react";
import './SettingModal.css'
import CustomPopup from "../../../components/CustomPopup";
import {ThemeContext} from "../../../providers/themeContext/theme-context.tsx";
import {useMusicContext} from "../../../providers/musicProvider/music-player-context.tsx";
import {GAEvents} from "../../../common/utils/GA4/GAEvents.ts";

type SettingModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onShowPlayTip: () => void;
};
const SettingModal: React.FC<SettingModalProps> = ({isOpen, onClose, onShowPlayTip}) => {
    // music 管理器
    const musicManager = useMusicContext();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 是否播放音乐
    const [isPlayMusic, setIsPlayMusic] = useState(true);
    // 是否播放音效
    const [isPlaySound, setIsPlaySound] = useState(true);
    // 是否同步数据
    const [isSyncData, setIsSyncData] = useState(true);

    useEffect(() => {
        if(isOpen) {
            // GA埋点
            GAEvents.settingShow()
            setIsPlaySound(musicManager.getState().isPlaySound)
            setIsPlayMusic(musicManager.getState().isPlayMusic)
            setIsSyncData(musicManager.getState().shareData)
        }
    }, [isOpen]);

    // 切换开关
    const toggleSwitch = (key: string) => {
        if (key === 'music') {
            // GA埋点
            GAEvents.settingButtonClick('Music')
            if (isPlayMusic) {
                musicManager.setState({...musicManager.getState(),isPlayMusic: !isPlayMusic})
                setIsPlayMusic(!isPlayMusic)
                musicManager.pauseMusic()
            } else {
                musicManager.setState({...musicManager.getState(),isPlayMusic: !isPlayMusic})
                setIsPlayMusic(!isPlayMusic)
                musicManager.playMusic()
            }

        } else if (key === 'sound') {
            // GA埋点
            GAEvents.settingButtonClick('Sound')
            musicManager.setState({...musicManager.getState(),isPlaySound: !isPlaySound})
            setIsPlaySound(!isPlaySound)
            musicManager.playButtonSound()
        } else if (key === 'Data sharing') {
            // GA埋点
            GAEvents.settingButtonClick('Data sharing')
            musicManager.setState({...musicManager.getState(),shareData: !isSyncData})
            setIsSyncData(!isSyncData)
        }
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl} alt="pic"/>
                {/*标题*/}
                <div className="modal-title my-roboto-bold">
                    Settings
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="right-close-button"
                         alt="关闭"/>
                </div>
                {/*游戏提示*/}
                <div className="modal-option-container my-roboto-medium">
                    <div className="modal-option-left-text my-roboto-medium">How to play</div>
                    <img onClick={onShowPlayTip} src={imgUrls.helpIconUrl}
                         className="modal-option-right-how-icon"
                         alt="提示"/>
                </div>
                {/*是否播放音乐*/}
                <div className="modal-option-container">
                    <div className="modal-option-left-text my-roboto-medium">Music</div>
                    {isPlayMusic ?
                        <img onClick={() => toggleSwitch("music")} src={imgUrls.switchBtnOpenUrl}
                             className="modal-option-right-icon"
                             alt="开关"/> :
                        <img onClick={() => toggleSwitch("music")} src={imgUrls.switchBtnCloseUrl}
                             className="modal-option-right-icon"
                             alt="开关"/>}
                </div>
                {/*是否播放按钮音效*/}
                <div className="modal-option-container my-roboto-medium">
                    <div className="modal-option-left-text my-roboto-medium">Sound</div>
                    {isPlaySound ?
                        <img onClick={() => toggleSwitch("sound")} src={imgUrls.switchBtnOpenUrl}
                             className="modal-option-right-icon"
                             alt="开关"/> :
                        <img onClick={() => toggleSwitch("sound")} src={imgUrls.switchBtnCloseUrl}
                             className="modal-option-right-icon"
                             alt="开关"/>}
                </div>
                {/*是否同步数据*/}
                <div className="modal-option-container my-roboto-medium">
                    <div className="modal-option-left-text my-roboto-medium">Data sharing</div>
                    {isSyncData ?
                        <img onClick={() => toggleSwitch("Data sharing")} src={imgUrls.switchBtnOpenUrl}
                             className="modal-option-right-icon"
                             alt="开关"/> :
                        <img onClick={() => toggleSwitch("Data sharing")} src={imgUrls.switchBtnCloseUrl}
                             className="modal-option-right-icon"
                             alt="开关"/>}
                </div>
            </div>
        </CustomPopup>
    );
};

export default SettingModal;